export const portalReleaseId = import.meta.env.VITE_PORTAL_RELEASE || "dev";
